import "./Insights.module.css";
import Header from "@/reusable_sections/Header";
import ExpertAnimalAdvice from "./sections/ExpertAnimalAdvice";
import NewsletterDeOfertas from "./sections/NewsletterDeOfertas";
import Footer from "@/reusable_sections/Footer";
export default function InsightsPage() {
  return <div>
      <Header />
      <ExpertAnimalAdvice />
      <NewsletterDeOfertas />
      <Footer />
    </div>;
}